import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
    component: Dashboard,
})

function Dashboard() {
    return (
        <div className="p-6 max-w-7xl mx-auto animate-fade-in">
            {/* Hero */}
            <header className="mb-8">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 mb-4">
                    <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                    <span className="text-sm text-blue-300">Legali Project Hub</span>
                </div>
                <h1 className="text-3xl font-bold text-white mb-2">
                    Welcome to Legali Docs
                </h1>
                <p className="text-slate-400">
                    Unified platform for documentation and task management.
                </p>
            </header>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <StatCard title="Documents" value="20" subtitle="Markdown files" icon="📚" />
                <StatCard title="Tasks" value="--" subtitle="Loading..." icon="✅" />
                <StatCard title="Team" value="9" subtitle="Collaborators" icon="👥" />
            </div>

            {/* Quick Actions */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <QuickAction
                    href="/docs"
                    title="Browse Documentation"
                    description="Explore project documentation, architecture guides, and API references."
                    icon="📖"
                    gradient="from-blue-600 to-blue-700"
                />
                <QuickAction
                    href="/tasks"
                    title="Task Board"
                    description="View and manage tasks in a Kanban-style board."
                    icon="📋"
                    gradient="from-purple-600 to-purple-700"
                />
            </div>

            {/* Recent Activity */}
            <section className="mt-8">
                <h2 className="text-lg font-semibold text-white mb-4">Recent Activity</h2>
                <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-6 text-center">
                    <p className="text-slate-400 mb-4">
                        Sign in to see your activity and assigned tasks.
                    </p>
                </div>
            </section>
        </div>
    )
}

function StatCard({ title, value, subtitle, icon }: {
    title: string
    value: string
    subtitle: string
    icon: string
}) {
    return (
        <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-5 hover:border-slate-600 transition-colors">
            <div className="flex items-start justify-between">
                <div>
                    <p className="text-sm text-slate-400 mb-1">{title}</p>
                    <p className="text-2xl font-bold text-white">{value}</p>
                    <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
                </div>
                <span className="text-2xl">{icon}</span>
            </div>
        </div>
    )
}

function QuickAction({ href, title, description, icon, gradient }: {
    href: string
    title: string
    description: string
    icon: string
    gradient: string
}) {
    return (
        <a
            href={href}
            className={`group bg-gradient-to-br ${gradient} rounded-xl p-5 hover:scale-[1.02] transition-transform`}
        >
            <span className="text-3xl mb-3 block">{icon}</span>
            <h3 className="text-lg font-semibold text-white mb-1">{title}</h3>
            <p className="text-white/80 text-sm">{description}</p>
        </a>
    )
}
